/**资源库模块 */
import request from '../request/http';
/**获取资源数量 */
export function GetResDataCount(data){
    return request({
        url: '/sp/resLib/getResDataCount',
        method: 'post',
        data
    })
}
/**查询热门资源 */
export function GetTopData(data){
    return request({
        url: '/sp/resLib/getTopData',
        method: 'post',
        data
    })
}
/**分页查询资源 */
export function PageResourceList(data){
    return request({
        url: '/sp/resLib/pageList',
        method: 'post',
        data
    })
}